// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"eaa2ceba","328":"31f5165d","453":"7cc6a38f","567":"86c1f8e7","772":"502f0a37","889":"6a8d9186"}[chunkId] + ".chunk.js";
};